<dtm-main-page-lib-welcome-section></dtm-main-page-lib-welcome-section>
<dtm-main-page-lib-where-you-can-fly-banner />
<dtm-main-page-lib-services-section></dtm-main-page-lib-services-section>
<!--  TODO: REJ-2688 enable after translations ready -->
<!-- <dtm-main-page-lib-faq [id]="FAQ_SECTION"></dtm-main-page-lib-faq> -->
<dtm-main-page-lib-prompt></dtm-main-page-lib-prompt>
